export const WATCH_HOW_IT_WORKS_LINK =
  'https://player.vimeo.com/video/607500622?h=48fb7d59d9';
export const IMAGE_PLACEHOLDER =
  'https://cdn.filestackcontent.com/dbgevdP3RMawFh9s1RsI';
